module.exports = __webpack_public_path__ + "static/media/Benifits5.0718671d.png";